module.exports = __webpack_public_path__ + "static/media/user.d9dbcc10.png";